<template>
  <div style="font-size: 14px; width: 100%">
    <div class="buy-layout buy-order-layout">
      <div class="buy-layout-header">
        <div class="buy-layout-header-inner">
          <div class="buy-layout-header-title">
            <div class="pay-layout-header-title">确认产品信息</div>
          </div>
          <div class="buy-layout-header-sub-title">
            <div class="buy-divider buy-divider-vertical"></div>
            <a v-show="platform" class="buy-link" @click="toGoodsInfo">返回修改配置</a>
          </div>
        </div>
      </div>

      <div class="buy-layout-body">
        <div class="buy-layout-body-inner">
          <div class="buy-layout-main">
            <div class="buy-layout-main-inner">
              <div class="tea-card">
                <div class="tea-card__body">
                  <div class="tea-card__title">
                    <div class="tea-justify-grid">
                      <div class="tea-justify-grid__col tea-justify-grid__col--left">
                        <h3 class="tea-h3">产品清单</h3>
                      </div>
                    </div>
                  </div>
                  <div class="tea-card__content">
                    <el-table :data="cartData" border :header-cell-style="{ background: '#f9f9f9' }"
                      style="width: 100%">
                      <el-table-column prop="title" label="产品名称" align="center">
                      </el-table-column>
                      <el-table-column prop="specName" label="规格" align="center" width="180">
                      </el-table-column>
                      <el-table-column prop="price" label="单价" align="center" width="180">
                      </el-table-column>
                      <el-table-column prop="count" label="数量" align="center" width="180">
                      </el-table-column>
                      <el-table-column prop="subtotal" label="小计" align="center" width="180">
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

              <div class="tea-card pay-card-coupon" style="margin-top: 20px">
                <div class="tea-card__body">
                  <div class="tea-card__title">
                    <div class="tea-justify-grid">
                      <div class="tea-justify-grid__col tea-justify-grid__col--left">
                        <div style="display: flex">
                          <h3 class="tea-h3">优惠券</h3>
                          <a class="sdk-opc-voucher-btn--link" @click="handleOpenCoupon">兑换优惠券</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tea-card__content">
                    <div class="coupon-way">
                      <div class="coupon-info" v-if="!couponData.length">
                        <div class="option-inner">
                          <div class="option-text">暂无可用优惠券</div>
                        </div>
                      </div>
                      <template v-for="coupon in couponData">
                        <!-- 优惠券 -->
                        <div v-if="coupon.type !== 2" class="option" :key="coupon.id" :class="{
                          'option-active': selectedCouponId === coupon.id,
                          'option-disabled':
                            coupon.goodsId !== cartData[0].goodsId,
                        }" @click="selectCoupon(coupon)">
                          <div class="option-inner">
                            <div class="option-coupon">
                              <el-radio v-model="selectedCouponId" :label="coupon.id" class="pay-icon" :disabled="coupon.goodsId !== cartData[0].goodsId
                                ">
                                <span class="option-title">优惠券</span>
                                <span class="option-text">¥{{ coupon.amount }}
                                </span>
                              </el-radio>
                              <!-- 不可用 -->
                              <span v-if="coupon.goodsId !== cartData[0].goodsId"
                                class="option-disabled">(该优惠券当前商品不可用)</span>
                            </div>
                            <!-- 适用商品 -->
                            <div class="option-goods">
                              <span class="goods-name">适用商品：</span>
                              <span class="goods-list">{{
                                coupon.goodsInfo?.title
                              }}</span>
                            </div>
                            <div class="option-expire-time">
                              <span v-if="coupon.expireTime" class="expire-time">有效期至：{{
                                new Date(coupon.expireTime)
                                | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                              }}</span>
                              <span v-else class="expire-time">长期有效</span>
                            </div>
                          </div>
                        </div>
                        <!-- 折扣券 -->
                        <div v-else class="option" :key="coupon.id" :class="{
                          'option-active': selectedCouponId === coupon.id,
                        }" @click="selectCoupon(coupon)">
                          <div class="option-inner">
                            <div class="option-coupon">
                              <el-radio v-model="selectedCouponId" :label="coupon.id" class="pay-icon">
                                <span class="option-title">折扣券</span>
                                <span class="option-text">{{ coupon.amount }}%
                                </span>
                              </el-radio>
                            </div>
                            <!-- 适用商品 -->
                            <div class="option-goods">
                              <span class="goods-name">适用商品：</span>
                              <span class="goods-list">全部商品</span>
                            </div>
                            <div class="option-expire-time">
                              <span v-if="coupon.expireTime" class="expire-time">有效期至：{{
                                new Date(coupon.expireTime)
                                | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                              }}</span>
                              <span v-else class="expire-time">长期有效</span>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-order-card">
      <div class="card-container">
        <div class="submit-info">
          <div class="coupon-info">
            <span class="label">优惠金额</span>
            <span class="price">
              {{
                selectedCouponId
                  ? couponData.find((coupon) => coupon.id === selectedCouponId)
                    .type === 2
                    ? (
                      $store.getters["cart/totalPrice"] *
                      ((100 - couponData.find(
                        (coupon) => coupon.id === selectedCouponId
                      ).amount) /
                        100)
                    ).toFixed(2)
                    : `-¥${couponData
                      .find((coupon) => coupon.id === selectedCouponId)
                      .amount.toFixed(2)}`
                  : 0
              }}
              <!-- -¥{{selectedCouponId ? couponData.find(coupon => coupon.id === selectedCouponId).amount.toFixed(2) : 0}} -->
              <span class="unit">元</span>
            </span>
          </div>
          <div class="pay-info">
            <span class="label">实付金额</span>
            <span class="price">
              ¥{{ couponAmount }}
              <span class="unit">元</span>
            </span>
          </div>
          <el-button class="tea-btn submit-btn" size="large" @click="handleBuy">去支付</el-button>
        </div>
      </div>
    </div>

    <!-- 兑换优惠券对话框 -->
    <coupon :dialogCouponVisible.sync="dialogCouponVisible" @event="handleCouponRedeemed"></coupon>
  </div>
</template>

<script>
import { orderService } from "@/api/orders";
import { couponsService } from "@/api/coupons";
import Coupon from "./components/Coupon";

export default {
  name: "OrderCart",
  components: {
    Coupon,
  },
  data() {
    return {
      fileWebSite: process.env.VUE_APP_FILE_URL,
      cartData: undefined,
      platform: undefined,
      couponData: undefined,
      selectedCouponId: null,
      dialogCouponVisible: false, // 控制兑换优惠券对话框的显示
    };
  },
  computed: {
    // 计算优惠券金额
    couponAmount() {
      const selectedCoupon = this.couponData.find(
        (coupon) => coupon.id === this.selectedCouponId
      );
      // 如果有选中的优惠券，计算总价减去优惠券金额，否则返回总价
      const totalPrice = this.$store.getters["cart/totalPrice"];
      if (selectedCoupon) {
        const amount = selectedCoupon.type === 2
          ?
          // 折扣券
          (
            totalPrice *
            ((100 - selectedCoupon.amount) / 100)
          ).toFixed(2)
          :
          // 优惠券
          selectedCoupon.amount;
        return totalPrice - amount < 0 ? 0 : (totalPrice - amount).toFixed(2);
      }
      return totalPrice.toFixed(2);
    },
  },
  created() {
    this.getGoods();
    this.getCouponList();
  },
  methods: {
    getGoods() {
      this.$store.dispatch("cart/loadCart");
      this.cartData = this.$store.getters["cart/carts"].map((item) => {
        return {
          goodsId: item.id,
          title: item.title,
          specName: item.specName,
          price: item.price,
          count: item.count,
          subtotal: item.price * item.count,
        };
      });
      this.platform = this.$store.getters["cart/carts"][0].platform;
    },
    getCouponList() {
      // 获取可用的优惠券列表
      couponsService.getAvailableCoupons().then((res) => {
        this.couponData = res;
      });
    },
    // 选中优惠券
    selectCoupon(coupon) {
      if (coupon.type !== 2) {
        // 不是折扣券，且不适用当前商品
        if (coupon.goodsId !== this.cartData[0].goodsId) {
          this.$message.warning("该优惠券当前商品不可用");
          return;
        }
      }

      if (this.selectedCouponId === coupon.id) {
        this.selectedCouponId = null; // 取消选中
      } else {
        this.selectedCouponId = coupon.id; // 选中优惠券
      }
    },
    // 打开兑换优惠券对话框
    handleOpenCoupon() {
      this.dialogCouponVisible = true;
    },
    // 处理兑换优惠券成功的事件
    handleCouponRedeemed() {
      this.$message.success("优惠券兑换成功");
      // 更新优惠券列表
      this.getCouponList();
      // 触发选中最新兑换的优惠券
      // this.selectedCouponId = response.id;
    },
    toGoodsInfo() {
      this.$router.push({ path: `/goods/${this.platform}` });
    },
    handleBuy() {
      orderService
        .createOrder({
          total: this.$store.getters["cart/totalPrice"],
          orderItems: this.$store.getters["cart/carts"].map((item) => {
            return {
              goodsId: item.id,
              title: item.title,
              img: item.img,
              platform: item.platform,
              count: item.count,
              specName: item.specName,
              price: item.price,
            };
          }),
          // couponId: this.selectedCouponId,
          orderCoupon: this.selectedCouponId
            ? {
              couponId: this.selectedCouponId,
            }
            : null,
        })
        .then((res) => {
          if (res) {
            this.$store.dispatch("cart/clearCart");
            this.$router.push({
              path: `/order/pay`,
              query: { orderNo: res.orderNo },
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.buy-layout {
  min-height: calc(100vh - 382px);
}

.buy-order-layout {
  min-width: 1180px;
}

@media only screen and (min-width: 1756px) {
  .buy-layout {
    max-width: 1660px;
  }
}

.buy-layout {
  max-width: 1180px;
  margin: 0 auto;
  padding-bottom: 112px;
  font-size: 14px;
}

.buy-layout-header {
  padding-top: 40px;
}

.buy-layout-header-inner {
  display: flex;
  align-items: baseline;
}

.buy-layout-header-title {
  float: left;
  font-size: 32px;
  font-weight: 700;
}

.buy-layout-header-title {
  float: left;
  font-size: 32px;
  font-weight: 700;
}

.buy-layout-header .buy-layout-header-title {
  font-weight: 400;
}

.buy-layout-header-sub-title {
  float: left;
}

.buy-layout-header-sub-title .buy-divider {
  margin: 0 12px;
  vertical-align: middle;
}

.buy-divider-vertical {
  display: inline-block;
  width: 1px;
  height: 16px;
}

.buy-divider {
  // height: 1px;
  overflow: hidden;
  background: #e2e6ed;
}

.buy-layout-header .buy-layout-header-sub-title .buy-link {
  color: #0052d9;
}

a {
  background-color: transparent;
  text-decoration: none;
  color: #006eff;
  cursor: pointer;
}

.buy-layout-body {
  min-height: inherit;
  position: relative;
}

.buy-layout-body {
  margin-top: 40px;
}

.buy-layout-body .buy-layout-body-inner {
  min-height: auto;
}

.buy-layout-body-inner {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

@media only screen and (min-width: 1756px) {
  .buy-layout .buy-layout-main {
    width: 100%;
  }
}

.buy-layout-main {
  width: 830px;
  display: block;
}

.buy-layout-main {
  width: 829px;
}

.buy-layout-main,
.buy-layout-side {
  vertical-align: top;
  display: table-cell;
}

@media only screen and (min-width: 1756px) {
  .buy-layout .buy-layout-main .buy-layout-main-inner {
    padding: 0;
  }
}

.buy-layout-main-inner {
  padding: 0 20px 0 0;
}

.tea-card {
  font-size: 30px;
  background: none;
  box-shadow: 0 0 0 transparent;
}

.tea-card {
  // background-color: #fff;
  // box-shadow: 0 2px 4px 0 rgba(54, 58, 80, .32);
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.9);
}

.tea-card__body {
  font-size: 12px;
  padding: 0px;
}

.tea-card__title {
  margin-bottom: 12px;
}

.tea-justify-grid {
  display: flex;
  width: 100%;
  align-items: center;
  color: rgba(0, 0, 0, 0.9);
  box-sizing: border-box;
}

.tea-justify-grid .tea-justify-grid__col--left,
.tea-justify-grid .tea-justify-grid__col:first-child {
  text-align: left;
}

.tea-justify-grid .tea-justify-grid__col {
  flex: auto;
  vertical-align: middle;
  text-align: right;
  font-size: 0;
}

.tea-card__title .tea-h3 {
  font-size: 18px;
  font-weight: 700;
}

.tea-card__title .tea-h3,
.tea-card__title h3 {
  color: #000;
}

.tea-card__title .tea-h3:before {
  position: relative;
  top: -2px;
  display: inline-block;
  content: "";
  width: 4px;
  height: 22px;
  background: #0052d9;
  vertical-align: middle;
  margin: 0 10px 0 0;
}

.sdk-opc-voucher-btn--link {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: 10px;
  color: #0052d9;
  font-size: 14px;
  line-height: 25px;
}

.submit-order-card {
  background: #fff;
  box-shadow: 0 0 12px rgba(24, 44, 108, 0.15);
  // position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  width: 100%;
  min-width: 1180px;
  height: 88px;
  z-index: 98;
}

.submit-order-card .card-container {
  height: 100%;
  max-width: 1180px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.submit-order-card .card-container .submit-info {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.submit-order-card .card-container .submit-info .coupon-info {
  display: flex;
  align-items: center;
  margin-right: 32px;
}

.submit-order-card .card-container .submit-info .coupon-info .label {
  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;
  font-weight: 400;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.9);
  margin-right: 16px;
}

.submit-order-card .card-container .submit-info .coupon-info .price {
  color: #ff7200;
  margin-left: 4px;
  font-weight: 500;
  font-size: 22px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  display: inline-block;
}

.submit-order-card .card-container .submit-info .coupon-info .price .unit {
  font-size: 12px;
}

.submit-order-card .card-container .submit-info .pay-info {
  display: flex;
  align-items: center;
  margin-right: 32px;
}

.submit-order-card .card-container .submit-info .pay-info .label {
  color: rgba(0, 0, 0, 0.9);
  font-size: 14px;
  font-weight: 400;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.9);
  margin-right: 16px;
}

.submit-order-card .card-container .submit-info .pay-info .price {
  color: #ff7200;
  margin-left: 4px;
  font-weight: 500;
  font-size: 22px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  display: inline-block;
}

.submit-order-card .card-container .submit-info .pay-info .price .unit {
  font-size: 12px;
}

.submit-order-card .card-container .submit-info .submit-btn {
  width: 136px;
  height: 40px;
  background-color: #0052d9;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
}

.coupon-way {
  // display: flex;
  margin-right: -12px;
}

.coupon-way .option-inner .option-text {
  // display: flex;
  // flex-direction: column;
  height: 100%;
  font-size: 16px;
}

.coupon-way .option {
  background: #fff;
  border: 1px solid #e2e6ed;
  min-height: 130px;
  width: calc(50% - 12px);
  flex: 1;
  padding: 20px;
  position: relative;
  box-sizing: border-box;
  margin-right: 12px;
  margin-bottom: 12px;

  float: left;
}

.coupon-way .option:hover {
  cursor: pointer;
  border: 1px solid #0052d9;
}

.coupon-way .option-active {
  border: 1px solid #0052d9;
}

.coupon-way .option-coupon .option-title {
  font-size: 16px;
  font-weight: 700;
}

.coupon-way .option-coupon .option-text {
  padding-left: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #ff7200;
}

.coupon-way .option-goods {
  margin-top: 5px;
  font-size: 14px;
  color: #333;
}

.coupon-way .option-goods .goods-name {
  font-weight: 700;
}

.coupon-way .option-goods .goods-list {
  color: #999;
}

.coupon-way .option-expire-time {
  margin-top: 5px;
  font-size: 14px;
  color: #999;
}
</style>
